import { login, logout, getInfo, getLatestAboutUs } from '@/api/login'
import { getToken, setToken, removeToken, setmenuLists } from '@/utils/auth'
import { listSysMessageSend } from '@/api/information'

import { Message } from 'element-ui'
const user = {
  state: {
    token: getToken(),
    name: '',
    phone: '',
    avatar: '',
    userName: '',
    roleName: '',
    orgName: '',
    roles: [],
    permissions: ["*:*:*"],
    news: [],
    num: 0,
    aboutUsInfo: null, // 关于我们信息缓存
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
    SET_ROLENAME: (state, roleName) => {
      state.roleName = roleName
    },
    SET_ORGNAME: (state, orgName) => {
      state.orgName = orgName
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_NEWS: (state, news) => {
      state.news = news
    },
    SET_NUM: (state, num) => {
      state.num = num
    },
    SET_ABOUTUS_INFO: (state, aboutUsInfo) => {
      state.aboutUsInfo = aboutUsInfo
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await login(userInfo)

          // 防御性编程：验证响应数据结构
          if (!res || !res.data) {
            console.error('登录响应数据格式错误:', res)
            // reject(new Error('登录响应数据格式错误'))
            return
          }

          const { token } = res.data
          if (!token) {
            console.error('登录响应中缺少token:', res.data)
            reject(new Error('登录失败：未获取到有效的登录凭证'))
            return
          }

          // 设置token和用户数据
          setToken(token)
          console.log('登录成功:', res)
          localStorage.setItem('menuList', JSON.stringify(res.data))
          commit('SET_TOKEN', token)
          resolve(res)

        } catch (error) {
          console.error('登录失败:', error)
          reject(error)
        }
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {

          // const user = res.user
          // const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/images/profile.jpg") : process.env.VUE_APP_BASE_API + user.avatar;
          // if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
          //   commit('SET_ROLES', res.roles)
          //   commit('SET_PERMISSIONS', res.permissions)
          // } else {
          //   commit('SET_ROLES', ['ROLE_DEFAULT'])
          // }
          let avatar = res.data.avatar != '' ? res.data.avatar : require('../../assets/mrtx.png')
          commit('SET_NAME', res.data.nickName)
          commit('SET_AVATAR', avatar)
          commit('SET_PHONE', res.data.phone)
          commit('SET_USERNAME', res.data.userName)
          commit('SET_ROLENAME', res.data.roleName)
          commit('SET_ORGNAME', res.data.orgName)
          commit('SET_ROLES', [res.data.role_id])

          // 同时获取关于我们信息并缓存
          getLatestAboutUs().then(aboutUsRes => {
            if (aboutUsRes.code === 200 && aboutUsRes.data) {
              commit('SET_ABOUTUS_INFO', aboutUsRes.data)
            }
          }).catch(error => {
            console.warn('获取关于我们信息失败:', error)
          })

          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取消息通知
    GetNews({ commit, state }) {
      return new Promise((resolve, reject) => {
        listSysMessageSend({
          pageSize: 9999999,
          pageNum: 1
        }).then(res => {
          let num = 0
          res.rows.forEach(v => {
            if (v.readFlag == 0) {
              num++
            }
          })
          commit('SET_NEWS', res.rows)
          commit('SET_NUM', num)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_NEWS', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          localStorage.removeItem('menuList')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 更新关于我们信息缓存
    UpdateAboutUsInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getLatestAboutUs().then(res => {
          if (res.code === 200 && res.data) {
            commit('SET_ABOUTUS_INFO', res.data)
            resolve(res.data)
          } else {
            reject(new Error('获取关于我们信息失败'))
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
